import React from 'react';
import './servicesHead.scss';

const ServicesHead = () => {
    return (
        <div className="service_head">
            <div className="service_head_main">Kadoshi <span className="service_head_sub">Services!</span></div>
            <div className="service_head_body">explore our massive database of qualified proffesionals in their various feilds of <br/> enterprise.
             Simply search or select a category and get access to them!
            </div>
        </div>
    )

}

export default ServicesHead;